module.exports = __webpack_public_path__ + "static/media/CR.a74494c3.png";